import {createAction, props} from '@ngrx/store';
import {Lesson} from "../models/lesson.model";
import {Course} from "../models/course.model";

export type Description = {id:string, description:string};


export const saveDescription = createAction(
  '[Description] Save  Description',
  props<Description>()
);

export const saveDescriptionSynchronizedClones = createAction(
  '[Description] Save Synchronized Clones',
  props<{ description: Description, lessons: Lesson[], courses: Course[]}>()
);

export const loadDescription = createAction(
  '[Description] Load Description',
  props<{descriptionId: string}>()
);

export const addDescription = createAction(
  '[Description] Add Course Description',
  props<Description>()
);

export const addDescriptions = createAction(
  '[Description] Add Courses Descriptions',
  props<{ descriptions: Description[] }>()
)


